/**
 * Notification types for Iteration 6 - Notifications & Sharing.
 */

/**
 * Types of notifications that can be sent to users.
 */
export const NotificationType = {
  NEW_COMMENT: 'NEW_COMMENT',
  MENTION: 'MENTION',
  POST_MODERATED: 'POST_MODERATED',
  COMMENT_MODERATED: 'COMMENT_MODERATED',
  SYSTEM: 'SYSTEM',
} as const;

export type NotificationType = (typeof NotificationType)[keyof typeof NotificationType];

/**
 * Types of references for notifications.
 */
export const ReferenceType = {
  POST: 'POST',
  COMMENT: 'COMMENT',
} as const;

export type ReferenceType = (typeof ReferenceType)[keyof typeof ReferenceType];

/**
 * Notification entity from the backend.
 */
export interface Notification {
  id: string;
  userId: string;
  type: NotificationType;
  title: string;
  message: string;
  referenceId: string | null;
  referenceType: ReferenceType | null;
  read: boolean;
  createdAt: string;
}

/**
 * Response for paginated notifications.
 */
export interface NotificationsPage {
  content: Notification[];
  totalPages: number;
  totalElements: number;
  size: number;
  number: number;
  first: boolean;
  last: boolean;
  empty: boolean;
}

/**
 * Response for unread notification count.
 */
export interface UnreadCountResponse {
  count: number;
}

/**
 * Response for share link generation.
 */
export interface ShareLinkResponse {
  postId: string;
  shareUrl: string;
  title: string;
  description: string;
  ogImageUrl: string | null;
}
